import React, { useMemo } from "react";
import "./SapGrid.css";
import SapCard from "../SapCard/SapCard";

export default function SapGrid({ itens = [], loading = false, onOpen }) {
  const itensOrdenados = useMemo(() => {
    return [...itens].sort((a, b) =>
      (a?.name || "").localeCompare(b?.name || "", "pt-BR", {
        sensitivity: "base",
        numeric: true,
      })
    );
  }, [itens]);

  if (loading) {
    return (
      <div className="sapGrid">
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className="sapCard skeleton" />
        ))}
      </div>
    );
  }

  if (!itensOrdenados.length) {
    return (
      <div className="sapEmpty">
        <div className="sapEmpty-emoji">🗂️</div>
        <div className="sapEmpty-title">Nada por aqui</div>
        <div className="sapEmpty-sub">Tente ajustar sua busca.</div>
      </div>
    );
  }

  return (
    <div className="sapGrid">
      {itensOrdenados.map((item) => (
        <SapCard key={item.id} data={item} onOpen={() => onOpen?.(item)} />
      ))}
    </div>
  );
}
